import type {
  Model,
  ModelServiceVisibility,
} from "../../services/api/instances/modelsApi/types";

export const getFilteredModels = (
  models: Model[],
  service: keyof ModelServiceVisibility
) => {
  return models.filter(
    (model) => (model?.visibility as ModelServiceVisibility)[service] === true
  );
};
